import { render, staticRenderFns } from "./LoadMessageContent.vue?vue&type=template&id=ccd89562"
import script from "./LoadMessageContent.vue?vue&type=script&lang=js"
export * from "./LoadMessageContent.vue?vue&type=script&lang=js"
import style0 from "./LoadMessageContent.vue?vue&type=style&index=0&id=ccd89562&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccd89562')) {
      api.createRecord('ccd89562', component.options)
    } else {
      api.reload('ccd89562', component.options)
    }
    module.hot.accept("./LoadMessageContent.vue?vue&type=template&id=ccd89562", function () {
      api.rerender('ccd89562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/LoadMessageContent.vue"
export default component.exports